import { useEffect } from 'react';

import { ChatBubbleIcon } from '@radix-ui/react-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from 'src/app/store';
//@ts-ignore
import chatNotification from 'src/assets/chat-notification.m4a'; // Import chatNotification sound
import { AddATripFlow } from 'src/features/add-trip';
import { setPlayNotificationSound } from 'src/features/chat/chat.slice';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';

import { ProfileDropdown } from './ProfileDropdown';

export function RightNav() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const shouldHideChatBubble = useShouldShowRideOrderingPortalFeatures();

  const { unreadMessageCount, playNotificationSound, sendbirdAccessToken } =
    useSelector((state: RootState) => state.chat);

  useEffect(() => {
    if (playNotificationSound) {
      const audio = new Audio(chatNotification);
      audio
        .play()
        .then(() => {
          dispatch(setPlayNotificationSound(false));
        })
        .catch(() => {
          // fail silently due to autoplay restrictions
        });
    }
  }, [dispatch, playNotificationSound]);

  return (
    <div className="z-10 flex items-center gap-4">
      <AddATripFlow />
      {/* 
        until we have a notification system in place, we should hide the bell icon
        we may be able to hide this and display notifications on the avatar for mobile
        <button
        type="button"
        className="rounded-full p-1 text-gray-500 hover:text-indigo focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
        data-testid="profile-avatar"
      >
        <span className="sr-only">View notifications</span>
        <BellIcon
          data-testid="bell-icon"
          className="h-6 w-6"
          aria-hidden="true"
        />
      </button> */}
      {!shouldHideChatBubble && sendbirdAccessToken && (
        <button
          onClick={() => {
            navigate('/chat');
          }}
          type="button"
          className="focus:ring-none rounded-full p-1 text-gray-500 hover:text-indigo focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
        >
          <span className="sr-only">View messages</span>
          <span className="relative inline-block">
            <ChatBubbleIcon data-testid="chat-icon" className="h-6 w-6" />
            {!!unreadMessageCount && (
              <span className="absolute top-0 right-0 inline-flex translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-red-600 px-2 py-1 text-xs font-bold leading-none text-red-100">
                {unreadMessageCount}
              </span>
            )}
          </span>
        </button>
      )}

      <ProfileDropdown />
    </div>
  );
}
